export const holiday = [
    {
        id: "H752762",
        holidayTitle: "New Year",
        date: "01 Jan 2024",
        description: "First day of the new year",
        status: "Active"
      },
      {
        id: "H752761",
        holidayTitle: "Martin Luther King Jr. Day",
        date: "15 Jan 2024",
        description: "Celebrating the civil rights leader",
        status: "Active"
      },
      {
        id: "H752760",
        holidayTitle: "Presidents' Day",
        date: "19 Feb 2024",
        description: "Honoring past US Presidents",
        status: "Active"
      },
      {
        id: "H752759",
        holidayTitle: "Good Friday",
        date: "29 Mar 2024",
        description: "Holiday before Easter",
        status: "Active"
      },
      {
        id: "H752758",
        holidayTitle: "Easter Monday",
        date: "01 Apr 2024",
        description: "Holiday after Easter",
        status: "Active"
      },
      {
        id: "H752757",
        holidayTitle: "Memorial Day",
        date: "27 May 2024",
        description: "Honors military personnel",
        status: "Active"
      },
      {
        id: "H752756",
        holidayTitle: "Independence Day",
        date: "04 Jul 2024",
        description: "Celebrates Independence",
        status: "Active"
      },
      {
        id: "H752755",
        holidayTitle: "Labor Day",
        date: "02 Sep 2024",
        description: "Honors working people",
        status: "Active"
      },
      {
        id: "H752754",
        holidayTitle: "Veterans Day",
        date: "11 Nov 2024",
        description: "Honors military veterans",
        status: "Active"
      },
      {
        id: "H752753",
        holidayTitle: "Christmas Day",
        date: "25 Dec 2024",
        description: "Celebration of Christmas",
        status: "Active"
      }
]
